import { userConstants } from "../constants/login.constants";

 function companiesDetailList(state = {}, action) {
    switch (action.type) {
        case userConstants.COMPANIESDETAILLIST_REQUEST:
            return {
                loading: true
            };
        case userConstants.COMPANIESDETAILLIST_SUCCESS:
            return {
                items: action.companiesDetailList
            };
        case userConstants.COMPANIESDETAILLIST_FAILURE:
            return {
                error: action.error
            };
        default:
            return state
    }
}
export default companiesDetailList;